import { AINewsConstants } from "../Constants/AINewsConstants.js";

const { ActionTypes } = AINewsConstants;

export const setMessage = (message) => ({
  type: ActionTypes.SET_MESSAGE,
  message,
});

export const fetchCompetitiveEdgeData = (symbol) => ({
  type: ActionTypes.GET_COMPETITIVE_EDGE_REQUEST,
  symbol,
});

export const setReaction = (newsType, selectedSegment = null, financialDetails = null, trackPriceDate = null) => ({
  type: ActionTypes.SET_AI_TEXT_REACTION,
  newsType,
  selectedSegment,
  financialDetails,
  trackPriceDate
});

export const setFutureEventReaction = (event_name, event_type, sentiment, feedback_description, feedback_type, comment) => ({
  type: ActionTypes.SET_FUTURE_EVENT_REACTION,
  event_name,
  event_type,
  sentiment,
  feedback_description,
  feedback_type,
  comment
});

export const saveReaction = (index, text, reaction, comments, date) => ({
  type: ActionTypes.SAVE_AI_REACTIONS,
  index,
  text,
  reaction,
  comments,
  date,
});

export const clearReactions = () => ({
  type: ActionTypes.CLEAR_REACTIONS,
});

export const fetchZigzagTrendData = (startDate, endDate, trendType) => ({
  type: ActionTypes.GET_ZIGZAG_TREND_DATA_REQUEST,
  startDate,
  endDate,
  trendType,
});

export const fetchFinancialBlockMetricsData = (metrics, date) => ({
  type: ActionTypes.GET_FINANCIAL_BLOCK_METRICS_DATA_REQUEST,
  metrics,
  date,
});

export const setPopupConfig = (showAIPopup, popupConfig) => ({
  type: ActionTypes.SET_POPUP_CONFIG,
  showAIPopup,
  popupConfig,
});

export const clearPopupConfig = () => ({
  type: ActionTypes.CLEAR_POPUP_CONFIG,
});

export const fetchTrackPriceAIData = (endDate, trendType) => ({
    type: ActionTypes.GET_TRACK_PRICE_AI_NEWS_REQUEST,
    endDate,
    trendType
});

export const closePopup = () => ({
  type: ActionTypes.CLOSE_POPUP,
});

export const setTriggerClose = (triggerClose) => ({
  type: ActionTypes.SET_TRIGGER_CLOSE,
  triggerClose
});

export const setAIFutureEventsGutterQtr = (aiFutureEventsGutterQtr) => ({
  type: ActionTypes.SET_AI_FUTURE_EVENTS_GUTTER_QTR,
  aiFutureEventsGutterQtr
});